import { render, staticRenderFns } from "./BindCard.vue?vue&type=template&id=07850e8e&scoped=true"
import script from "./BindCard.vue?vue&type=script&lang=js"
export * from "./BindCard.vue?vue&type=script&lang=js"
import style0 from "./BindCard.vue?vue&type=style&index=0&id=07850e8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07850e8e",
  null
  
)

export default component.exports